/**
 * Editorial content for the Top Subscribed IPOs page (/top-subscribed-ipos):
 * FAQs explaining how subscription multiples and allotment work. The ranking
 * itself comes from GET /api/market/subscription/top.
 */

export const TOP_SUBSCRIBED_FAQS = [
  {
    question: 'What does “times subscribed” mean?',
    answer:
      'It is the number of shares investors bid for divided by the shares offered to them. At 10x, bids came in for ten times the shares on offer. Anchor investors are allotted before the issue opens, so their portion sits outside this public book.',
  },
  {
    question: 'Does heavy oversubscription guarantee an allotment?',
    answer:
      'No. When the retail portion is oversubscribed, allotment is decided by a computerised lottery on lots, so many applicants get nothing. Applying for more lots does not improve your odds in the retail category — one application at one lot has the same chance as any other.',
  },
  {
    question: 'Why do SME IPOs show much higher subscription figures?',
    answer:
      'SME issues are small, often ₹20–50 crore against hundreds of crore on the mainboard, and individual investors must apply for at least two lots. A modest amount of money therefore produces a far larger multiple than the same demand would on a mainboard issue.',
  },
  {
    question: 'Does a high subscription mean listing gains?',
    answer:
      'Not reliably. Strong demand reflects sentiment during bidding, and grey market premiums are unofficial and often volatile. Listing prices depend on market conditions on listing day, and heavily subscribed issues have listed below their issue price before.',
  },
  {
    question: 'When do the final figures settle?',
    answer:
      'Bidding closes at 5:00 PM IST on the last day, which is also the deadline to approve UPI mandates. The exchanges publish consolidated final demand after the book closes; figures for an issue still open keep changing through the day.',
  },
];
